import React from "react";
import ReactDOM from "react-dom/client";
import Sentry, { sentryActivo } from "./sentry";
import "./index.css";
import App from "./App";
import { DataContextProvider } from "./contexts/AuthContext";
import { DebtsContextProvider } from "./contexts/FeeContext";
import { ExtraCostProvider } from "./contexts/extraCostContext";
import { LowerQuantityProvider } from "./contexts/LowerQuantityContext";

// Una excepción de React dejaba la pantalla en blanco y en silencio: el cliente no entendía nada
// y nosotros no nos enterábamos. Con Sentry activo la app va envuelta en su ErrorBoundary, que
// reporta el stack y además muestra algo en vez de la nada.
// 🪤 El ErrorBoundary de Sentry SIN `fallback` renderiza null = la misma pantalla en blanco de
// antes. El fallback no es decorativo.
const PantallaError = () => (
  <div style={{ padding: 32, fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
    <h2>Se nos rompió algo</h2>
    <p>Ya nos avisó solo. Probá recargar la página.</p>
    <button
      onClick={() => window.location.reload()}
      style={{ padding: "10px 20px", borderRadius: 8, border: 0, background: "#c026d3", color: "#fff", cursor: "pointer" }}
    >
      Recargar
    </button>
  </div>
);

// 🪤 `let`, no `const`: el código viejo de Bugsnag reasignaba una constante, y por eso no se podía
// destapar sin tirar la app entera en el arranque.
let ErrorBoundary = ({ children }) => <React.Fragment>{children}</React.Fragment>;
if (sentryActivo) {
  ErrorBoundary = ({ children }) => (
    <Sentry.ErrorBoundary fallback={<PantallaError />}>{children}</Sentry.ErrorBoundary>
  );
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <React.Fragment>
      <DataContextProvider>
        <DebtsContextProvider>
          <ExtraCostProvider>
            <LowerQuantityProvider>
          <App />
          </LowerQuantityProvider>
          </ExtraCostProvider>
        </DebtsContextProvider>
      </DataContextProvider>
    </React.Fragment>
  </ErrorBoundary>
);
